import {
  getMemberBookingInfoUrl, getBookingsByEntitlerAndIdPmsUrl,
  claimMyBookingUrl, uploadBookingPdfUrl
} from "../api/urls";
import { userConstants } from "../constants/user.constants";
import { userActions as authenticationActions } from "../actions/authenticationActions";
import { showModal } from './modalsActions';
import { TOOGLE_BOOKING_FORM, SHOW_BOOKING_FORM } from '../constants';

export function getUserBookings(authToken, brandId, isCatalog=false) {
  return dispatch => fetch(getMemberBookingInfoUrl + "?brandId=" + brandId + "&isCatalog="+isCatalog.toString(), {
    method: 'GET',
    headers: new Headers({
      'Accept': 'application/json',
      "X-Auth-Token": authToken
    })
  }).then(r => authenticationActions.handleResponse(r)(dispatch)
  ).then(v => {
    dispatch({ type: userConstants.LOY3_GET_BOOKINGS_SUCCESS, payload: v.responseObj })
  }).catch(err => {
    console.log("Error while trying to get user bookings: ", err)
    dispatch({ type: userConstants.LOY3_GET_BOOKINGS_FAILURE, err })
  });
}

export const fetchBooking = (authToken, idPms, pmsEntitler) => (dispatch) => {
  const url = `${getBookingsByEntitlerAndIdPmsUrl}?idPms=${idPms}&pmsEntitler=${pmsEntitler}`;
  return fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Accept': 'application/json',
      "X-Auth-Token": authToken
    })
  }).then(r => authenticationActions.handleResponse(r)(dispatch)).then(v => {
    if (v === "201") {
      dispatch({ type: userConstants.LOY3_FIND_BOOKING_SUCCESS, status: v.responseObj })
    } else {
      dispatch({ type: userConstants.LOY3_FIND_BOOKING_SUCCESS, status: "204" })
    }
    return { success: true };
  }).catch(err => {
    dispatch(showModal('bookingNotFound', { idPms, pmsEntitler }))
    dispatch({ type: userConstants.LOY3_FIND_BOOKING_FAILURE, status: err })
    return { success: false };
  })
}

export function claimBooking(authToken, bookingInfo) {
  return dispatch => fetch(claimMyBookingUrl, {
    method: 'POST',
    body: JSON.stringify(bookingInfo),
    headers: new Headers({
      'Accept': 'application/json',
      'Content-type': 'application/json',
      "X-Auth-Token": authToken
    })
  }).then(v => {
    if (v.status === 400 || v.status === 500) {
      return v.json().then(error => {
        throw error;
      });
    }
    return v.json();
  })
    .then(r => {
      dispatch({ type: userConstants.LOY3_CLAIM_BOOKING_SUCCESS, payload: r })
    })
}

export function uploadBookingPdf(authToken, pdf, fileName) {
  let formData = new FormData();
  formData.append("pdf", pdf);
  return dispatch => fetch(uploadBookingPdfUrl + (fileName ? '/?fileName=' + fileName : ''), {
    method: 'POST',
    body: formData,
    headers: new Headers({
      'Accept': '*/*',
      "X-Auth-Token": authToken
    })
  }).then(v => {
    dispatch({ type: userConstants.LOY3_CLAIM_BOOKING_WITH_PDF_SUCCESS, response: v })
  }).catch(err => {
    dispatch({ type: userConstants.LOY3_CLAIM_BOOKING_WITH_PDF_FAILURE, response: err })
  })
}

export const toggleBookingForm = () => dispatch => dispatch({ type: TOOGLE_BOOKING_FORM });
export const showBookingForm = () => dispatch => dispatch({ type: SHOW_BOOKING_FORM });
